<template>
    <div class="quote">
        <img class="quote-img" src="@/assets/quote.png" alt="">
        <h2>{{ quote }}</h2>
    </div>
</template>

<script>
export default {
    name:'Quote',
    props: {
        quote: {
            type: String,
            default: 'Welcome to TOPCV DASHBOARD'
        },
    },
}
</script>

<style>
    .quote-img{
        margin-bottom: 1em;
    }
    .quote{
        min-height: 295px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Quote.vue